import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { DomSanitizer, Title } from '@angular/platform-browser';

import { SnotifyService } from 'ng-snotify';

import { CoreService } from 'src/app/core/core.service';
import { Testimonial } from 'src/app/interfaces/testimonial';
import { SeoService } from 'src/app/services/seo.service';
import { Constants } from 'src/app/shared/constants.service';
import { Item } from 'src/app/interfaces/cart';
import { CartService } from 'src/app/services/cart.service';
import { formatCurrency } from '@angular/common';

@Component({
  selector: 'cm-class-details',
  templateUrl: './class-details.component.html',
  styleUrls: ['./class-details.component.scss']
})
export class ClassDetailsComponent implements OnInit {
  slug: string;
  course;
  packageCourses: any = [];
  testimonials: Testimonial[] = [];
  nextClasses: any = [];
  hasCoordinator: boolean = false;
  coursePaymentTypes: any[] = [];
  paymentTypes: any[] = [];

  form: FormGroup;
  displayDialog: boolean = false;
  citiesNames: any;
  private _cities;
  private _selectedCityId;
  is_pos:boolean = false;
  is_black:boolean = false;

  constructor(
    private _coreService: CoreService,
    private _activatedRoute: ActivatedRoute,
    private _formBuilder: FormBuilder,
    private _snotifyService: SnotifyService,
    private _domSanitizer: DomSanitizer,
    private _titleService: Title,
    private _seoService: SeoService,
    private _cartService: CartService,
  ) { }

  ngOnInit() {
    this._activatedRoute.params.subscribe(params => {
      this.course = this._activatedRoute.snapshot.data.courseData;
      this.setPaymentTypes();
      this._getNextClasses();
      this._getCoursesPackages();
      if(this.course.black_friday == true){
        this.course.payment_conditions = ["Até 1x no Boleto", "Até 1x no Cartão de Crédito"];
      }

      let setTitle = function(){
        const websiteTitle = 'CTEMER ';
        this._titleService.setTitle(websiteTitle + this.course.name);
      }
      setTimeout(setTitle.bind(this), 100);
    });

    this._activatedRoute.url.subscribe((url: any) => {
      let path = '';
      url.map(item => path += '/' + item.path);
      path = path.substring(1);
      this._seoService.defineTags(path);
    });

    if(this.course.media_type == 'video'){
      this.course.media_url = this._cleanUrl(this.course.media_url);
    }

    this.hasCoordinator = this.course.hasOwnProperty('coordinator') && this.course.coordinator.hasOwnProperty('name') ?  true : false;
    this._getTestimonialsRelated(this.course.id);
    this._activatedRoute.params.subscribe(params => {
      this.slug = params.slug;
    })

    this.form = this._formBuilder.group({
      course_id: [this.course.course[0].id, [Validators.required]],
      name: [null, [Validators.required]],
      email: [null, [Validators.required, Validators.email]],
      phone: [null, [Validators.required]],
      city: [null, [Validators.required]],
      captcha: [null, [Validators.required]]
    });

    this.course.pos ? this.is_pos = true : false;
    this.course.black_friday ? this.is_black = true : this.is_black = false;
  }

  // ----- PUBLIC METHODS
  toggleDialog(): void {
    this.displayDialog = !this.displayDialog;
  }

  captchaResponse(event): void {
    this.form.patchValue({captcha: event.response});
  }

  captchaExpires(): void {
    this.form.patchValue({captcha: null});
  }

  searchCity(event: any): void {
    let params = {'search_text': event.query};
    this._coreService.getCities(params).subscribe(response => {
      this._cities = response;
      this.citiesNames = response.map(city => city.name + ` - `+ city.uf);
    })
  }

  defineCity(cityName: any): void {
    this._cities.find(city => {
      if(city.name + ` - `+ city.uf === cityName){
        this._selectedCityId = city.id;
        return true;
      }
    })
  }

  send(): void {
    let params = this.form.getRawValue();
    params['city'] = this._selectedCityId;
    this._coreService.courseQueue(params).subscribe(() => {
      this.displayDialog = false;

      this._snotifyService.warning('Entraremos em contato quando próximas turmas abrirem para este curso.', 'Sucesso!', {
        timeout: 3000,
        showProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        position: 'centerTop'
      });
    })
  }

  // ----- PRIVATE METHODS
  private _getTestimonialsRelated(id: number): void {
    let params = {course_id: id};
    this._coreService.getTestimonials(params).subscribe((response: any) => {
      this.testimonials = response;
    })
  }

  private _getCoursesPackages(): void {
    const params = {
      only_packages: true,
      course_type_ids: [this.course.course_type_id]
    };
    this._coreService.searchCourses(params).subscribe((response: any) => {
      this.packageCourses = response.data;
    })
  }

  private _getNextClasses(): void {
    const params = {
      only_next_classes: true,
      course_type_ids: [this.course.course_type_id],
      city_id: this.course.city_id
    };
    this._coreService.searchCourses(params).subscribe((response: any) => {
      this.nextClasses = response.data;
    })
  }

  private _cleanUrl(url: string) {
    var regExp = /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|\&v=)([^#\&\?]*).*/;
    var match = url.match(regExp);

    if (match && match[2].length >= 11) {
      let url = 'https://www.youtube.com/embed/' + match[2];
      return this._domSanitizer.bypassSecurityTrustResourceUrl(url);
    } else {
      return 'error';
    }
  }

  addItemToCart() {
    const item:Item = {
      id: this.course.course[0].id,
      black_friday: this.course.black_friday,
      slug: this.slug,
      image: this.course.media_url,
      title: this.course.course[0].fullname,
      subtitle: this.course.course[0].fullname,
      date: this.course.date,
      place: this.course.city_uf,
      targetAudience: this.course.target_audience[0].audience,
      tag: this.course.course[0].slug,
      isPromotion: this.course.percentage_promotion > 0,
      descontoPromocao:this.course.percentage_promotion,
      remainTime: this.course.remainTime,
      remainText: this.course.remainText,
      isFull: this.course.is_full,
      isFinanciable: this.course.isFinanciable,
      isPos: this.course.pos,
      config_tipo_curso_id: this.course.config_tipo_curso_id,
      result_center_id: this.course.result_center_id,
      value: this.course.value,
      gt: this.course.gt,
      allow_card: this.course.allow_card,
      allow_billet: this.course.allow_billet,
      allow_pix: this.course.allow_pix,
      paymentTypes: this.course.class_payment_settings
    };

    this._cartService.addItemToCart(item);
  }

  setPaymentTypes() {
    const payment_category_cartao = 1;
    const payment_category_boleto = 2;
    const payment_category_pix = 7;

    this.course.class_payment_settings.sort((a, b) => a.start_installment - b.start_installment);

    this.course.class_payment_settings.forEach((value) => {
      if (value.payment_setting.payment_category_id == payment_category_boleto) {
        this.coursePaymentTypes.unshift(`${formatCurrency(value.price, "pt-BR", "R$")} à vista no boleto`);
      }
      if (value.payment_setting.payment_category_id == payment_category_cartao) {
        if (value.end_installment == 1) {
          this.coursePaymentTypes.push(`${formatCurrency(value.price, "pt-BR", "R$")} à vista no cartão`);
        } else {
          this.coursePaymentTypes.push(`${formatCurrency(value.price, "pt-BR", "R$")} de ${value.start_installment}x até ${value.end_installment}x no cartão`);
        }
      }
      if (value.payment_setting.payment_category_id == payment_category_pix) {
        this.coursePaymentTypes.unshift(`${formatCurrency(value.price, "pt-BR", "R$")} à vista no pix`);
      }
    });
  }
}
